import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  GridItem,
  HStack,
  Icon,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import { format, isToday } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getLatestReminders, getReminders } from '../../stores/slices/reminders/remindersActions';
import Card from '../Card';

const RemindersDash = () => {
  const { latestReminders, loading } = useSelector(state => state.reminders);
  // const [latestReminders, setLatestReminders] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLatestReminders());
  }, []);

  // old code for filtering reminders
  /*  useEffect(() => {
    const groups = reminders
      .filter(reminder => {
        if (
          isToday(new Date(reminder.due)) &&
          moment.utc(new Date(reminder.due_time)).format('HH:mm') >=
            moment(new Date()).format('HH:mm')
        ) {
          return true;
        }
        return (
          new Date(reminder.due) > new Date(format(new Date(), 'yyyy-MM-dd'))
        );
      })
      .sort((a, b) => new Date(a.due) - new Date(b.due))
      .slice(0, 3)
      .reduce((groups, reminder) => {
        const date = reminder.due;
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(reminder);
        return groups;
      }, {});
    const groupArrays = Object.keys(groups).map(date => {
      return {
        date,
        reminders: groups[date].sort(
          (a, b) => new Date(a.due_time) - new Date(b.due_time)
        ),
      };
    });

    setLatestReminders(groupArrays);
  }, [reminders]); */

  return (
    <Box w={'full'} h={'full'}>
      <Card
        mx={'auto'}
        flex={'1'}
        flexGrow={'1'}
        h={'full'}
        overflowY={'hidden'}
      >
        <VStack align={'start'} h={'full'}>
          <HStack mb={'4'}>
            <Text fontWeight={'bold'} fontSize="md" w="full">
              Reminders{' '}
            </Text>
            <Icon viewBox="0 0 200 200" color="primary">
              <path
                fill="currentColor"
                d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
              />
            </Icon>
          </HStack>
          <Box h={'full'} pb={'6'} flex={1} w={'full'}>
            <Scrollbars>
              <Flex
                overflowY="hidden"
                flexDirection="column"
                flex={1}
                w={'full'}
              >
                {loading ? (
                  <Spinner color="primary" />
                ) : latestReminders.length > 0 ? (
                  <Grid
                    w={'full'}
                    h="full"
                    templateColumns="repeat(3, 1fr)"
                    gap={'1'}
                    rowGap={'8'}
                  >
                    {latestReminders.map((item, index) => (
                      <React.Fragment key={item.date}>
                        <GridItem colSpan={3}>
                          <Text
                            fontWeight={'semibold'}
                            color={
                              isToday(new Date(item.date))
                                ? 'black'
                                : 'lightGray'
                            }
                          >
                            {isToday(new Date(item.date)) ? 'Today - ' : ''}{' '}
                            {format(new Date(item.date), 'MMMM do yyyy')}
                          </Text>
                        </GridItem>
                        {item.reminders.map((reminder, index) => (
                          <React.Fragment key={reminder.id}>
                            <GridItem minH={'70px'} colSpan={1}>
                              <HStack
                                h={'full'}
                                w={'full'}
                                justify={'space-around'}
                              >
                                <Flex
                                  align={'center'}
                                  justify={'center'}
                                  h={'full'}
                                >
                                  <Text fontWeight={'semibold'} fontSize="28">
                                    {reminder.due_time
                                      ? moment
                                          .utc(reminder.due_time)
                                          .format('HH:mm')
                                      : '00:00'}
                                  </Text>
                                </Flex>
                                <Box
                                  h={'full'}
                                  w={'1'}
                                  background={
                                    index % 2 === 0 ? 'primary' : 'lightGreen'
                                  }
                                  borderRadius={'2'}
                                />
                              </HStack>
                            </GridItem>
                            <GridItem colSpan={2}>
                              <VStack
                                h={'full'}
                                align={'start'}
                                justify={'space-around'}
                              >
                                <Text fontSize={'lg'} fontWeight={'semibold'}>
                                  {reminder.reminder}
                                </Text>
                                {reminder.users.length > 0 && (
                                  <Text color={'lightGray'}>
                                    {reminder.users.map((user, index) => (
                                      <span key={user.id}>
                                        {user.full_name}
                                        {reminder.users.length > 1 &&
                                        index < reminder.users.length - 1
                                          ? ', '
                                          : ''}
                                      </span>
                                    ))}
                                  </Text>
                                )}
                                <Text color={'lightGray'}>
                                  {reminder.description}
                                </Text>
                              </VStack>
                            </GridItem>
                          </React.Fragment>
                        ))}
                        {latestReminders.length > 1 &&
                        index < latestReminders.length - 1 ? (
                          <GridItem colSpan={3}>
                            <Divider />
                          </GridItem>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </Grid>
                ) : (
                  <Text>No reminders found</Text>
                )}
              </Flex>
            </Scrollbars>
          </Box>
          <Button
            background={'primaryOpaque'}
            color={'primary'}
            w={'full'}
            onClick={() => navigate('reminders')}
          >
            View More
          </Button>
        </VStack>
      </Card>
    </Box>
  );
};

export default RemindersDash;
